/*
 * Copyright (c) 2026 SimplyBook.me Ltd. All rights reserved.
 * Licensed under the Apache License, Version 2.0.
 */

import React from "react";
import Label from "./Label";
import { useController } from "react-hook-form";
import { StyledFormField, StyledSelectIcon, StyledSelectWrapper } from "./form/StyledFormField";
import { useTranslate } from "../../hooks/useTranslate";

const Select = ({
  name,
  control,
  label,
  options,
  placeholder,
  defaultValue,
  required = false,
  onChange,
  validationRules = {},
  ...props
}) => {
  const { _t } = useTranslate();
  const { field, fieldState } = useController({
    name,
    control,
    rules: {
      required: required ? "error_value_is_empty" : undefined,
      ...validationRules,
    },
    defaultValue: defaultValue || "",
  });

  return (
    <>
      {label ? (
        <Label name={name} required={required}>
          {label}
        </Label>
      ) : undefined}
      <StyledSelectWrapper>
        <StyledFormField.Select
          {...props}
          {...field}
          id={name}
          $error={fieldState.error}
          onChange={(e) => {
            field.onChange(e);
            if (onChange) onChange(e);
          }}
        >
          {placeholder && (
            <option value="" disabled>
              {_t(placeholder)}
            </option>
          )}
          {options.map((option, index) => (
            <option key={index} value={option.value}>
              {option.label}
            </option>
          ))}
        </StyledFormField.Select>
        <StyledSelectIcon />
      </StyledSelectWrapper>
    </>
  );
};

export default Select;
